import { createFileRoute } from "@tanstack/react-router";
import { RoomDisplay } from "@/features/room-display/RoomDisplay";

export const Route = createFileRoute("/room/$roomId/")({
  component: CompactRoomDisplay,
});

function CompactRoomDisplay() {
  const { roomId } = Route.useParams();
  return <RoomDisplay roomId={roomId} />;
}
